// extracted by mini-css-extract-plugin
export default {"backdrop":"Modal_backdrop__HSrXU","modal":"Modal_modal__aI+os","slide-down":"Modal_slide-down__xtXpj"};